import React from 'react';

export default function ResumoPedido({
  pedido,
  setNome,
  setTelefone,
  setEmail,
  setFormaPagamento,
  setTrocoPara,
  onConfirmar,
  onVoltar
}) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md space-y-4">
        <h2 className="text-xl font-bold text-center text-yellow-700 mb-4">Resumo do Pedido</h2>

        <div className="space-y-2">
          <div>
            <label className="font-semibold block mb-1">Nome *</label>
            <input
              type="text"
              value={pedido.nome_cliente}
              onChange={(e) => setNome(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label className="font-semibold block mb-1">Telefone *</label>
            <input
              type="text"
              value={pedido.telefone}
              onChange={(e) => setTelefone(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label className="font-semibold block mb-1">Email</label>
            <input
              type="email"
              value={pedido.email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>

          <div>
            <label className="font-semibold block mb-1">Forma de Pagamento *</label>
            <select
              value={pedido.forma_pagamento}
              onChange={(e) => setFormaPagamento(e.target.value)}
              className="w-full p-2 border rounded"
              required
            >
              <option value="">Selecione</option>
              <option value="Pix">Pix</option>
              <option value="Cartão">Cartão</option>
              <option value="Dinheiro">Dinheiro</option>
            </select>
          </div>

          {pedido.forma_pagamento === 'Dinheiro' && (
            <div>
              <label className="font-semibold block mb-1">Troco para quanto?</label>
              <input
                type="number"
                value={pedido.troco_para}
                onChange={(e) => setTrocoPara(e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Ex: 100.00"
              />
            </div>
          )}

          <div>
            <label className="font-semibold block mb-1">Unidade *</label>
            <select
              value={pedido.unidade}
              onChange={(e) => alert('A unidade deve ser escolhida antes, no cardápio.')}
              className="w-full p-2 border rounded"
              disabled
            >
              <option value="Penha">Penha</option>
              <option value="Sumaré">Sumaré</option>
            </select>
            <small className="text-gray-500">* Unidade selecionada anteriormente</small>
          </div>

          <div className="text-center mt-4">
            <h3 className="text-lg font-bold">Total: R$ {pedido.total.toFixed(2)}</h3>
          </div>

          <div className="flex gap-2 mt-6">
            <button
              onClick={onConfirmar}
              className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 rounded font-bold"
            >
              Confirmar Pedido
            </button>
            <button
              onClick={onVoltar}
              className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 rounded font-bold"
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
